<template>
  <div class="order">
    <div class="top">
      <div class="querybox">
        <div>
          <p>订单编号：</p>
          <el-input
            v-model="queryParams.orderNo"
            placeholder="请输入订单编号"
            clearable
          ></el-input>
        </div>
        <div>
          <p>订单状态：</p>
          <el-select
            v-model="queryParams.orderStatus"
            placeholder="请选择订单状态："
          >
            <el-option
              v-for="item in getDictDatas(DICT_TYPE.ORDER_STATUS)"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <p>下单时间：</p>
          <!-- <el-date-picker
            v-model="value"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker> -->
          <el-date-picker
            v-model="value"
            align="right"
            type="date"
            placeholder="选择时间"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <p>商品标题：</p>
          <el-input
            v-model="queryParams.goodsName"
            placeholder="请输入商品标题"
            clearable
          ></el-input>
        </div>
        <div>
          <p>收货人：</p>
          <el-input
            v-model="queryParams.name"
            placeholder="请输入收货人名称"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column
          prop="orderNo"
          label="订单编号"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品标题"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="goodsSkuName" label="规格信息" min-width="100">
        </el-table-column>
        <el-table-column prop="count" label="购买数量"> </el-table-column>
        <el-table-column prop="orderMoney" label="实付金额">
          <template slot-scope="{ row }"> ￥{{ row.orderMoney }} </template>
        </el-table-column>
        <el-table-column prop="postage" label="邮费">
          <template slot-scope="{ row }"> ￥{{ row.postage }} </template>
        </el-table-column>
        <el-table-column prop="name" label="收货人">
          <template slot-scope="{ row }">
            <el-button class="textBlue-btn" @click="checkConsignee(row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="payType" label="支付方式">
          <template slot-scope="{ row }">{{ row.payType_dictText }} </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="订单状态">
          <template slot-scope="{ row }">
            {{ row.orderStatus_dictText }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="下单时间" min-width="160">
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="{ row }">
            <el-popconfirm
              title="是否删除该订单？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(row.id)"
              v-if="row.orderStatus === -1"
            >
              <el-button
                class="textOrange-btn"
                style="margin-right: 10px"
                slot="reference"
                >删除订单</el-button
              >
            </el-popconfirm>
            <el-button
              class="textOrange-btn"
              v-if="row.orderStatus === 1 || row.orderStatus === 2"
              @click="goAgree(row)"
              >退款</el-button
            >
            <el-button
              class="textOrange-btn"
              v-if="row.orderStatus === 1"
              @click="checkSend(row)"
              >发货</el-button
            >
            <el-button
              class="textOrange-btn"
              v-if="row.orderStatus === 2 || row.orderStatus === 3"
              @click="checkLog(row)"
              >查看物流</el-button
            >
            <el-button class="textOrange-btn" @click="goDetails(row.id)"
              >订单详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 查看收货人信息 -->
    <el-dialog
      :visible.sync="consigneeVisible"
      width="30%"
      :before-close="consigneeClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>查看收货人信息</p>
        <span @click="consigneeClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="consignee-box">
        <p>
          收货人 <span>{{ itemInfo.name }}</span>
        </p>
        <p>
          联系方式 <span>{{ itemInfo.phone }}</span>
        </p>
        <p>
          下单地址 <span>{{ itemInfo.address }}</span>
        </p>
        <div
          type="text"
          class="copy-btn"
          @click="copyAddress"
          :data-clipboard-text="coord"
        >
          <img src="@/assets/shop/copy.png" alt="" />
          一键复制
        </div>
      </div>
    </el-dialog>
    <!-- 退款 -->
    <el-dialog
      :visible.sync="agreeVisible"
      width="30%"
      :before-close="agreeClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>是否退款该订单</p>
        <span @click="agreeClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-box">
        <div>
          <p>商品金额：</p>
          <span
            >￥{{
              (itemInfo.orderMoney - itemInfo.postage) / itemInfo.count
            }}</span
          >
        </div>
        <div>
          <p>邮费：</p>
          <span>￥{{ itemInfo.postage }}</span>
        </div>
        <div>
          <p>总计：</p>
          <span style="color: #ff5d2f">￥{{ itemInfo.orderMoney }}</span>
        </div>
        <div>
          <p>是否返回库存：</p>
          <el-radio-group v-model="isReturnStock">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="agreeClose">取 消</el-button>
        <el-button type="primary" class="enter-btn" @click="sumbitAgree()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 发货 -->
    <el-dialog
      :visible.sync="sendVisible"
      title="发货"
      width="35%"
      :before-close="handlesendClose"
      destroy-on-close
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>发货</p>
        <span @click="handlesendClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="address-box">
        <div class="name">
          <span>快递公司：</span>
          <el-select v-model="expressCode" placeholder="请选择">
            <el-option
              v-for="item in expressList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="expressCode == 8">
          <span>手机尾号4位：</span>
          <el-input
            v-model="phoneNo"
            placeholder="请输入手机尾号4位"
          ></el-input>
        </div>
        <div>
          <span>快递单号：</span>
          <el-input v-model="expressNo" placeholder="请输入快递单号"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="handlesendClose">取 消</el-button>
        <el-button type="primary" class="enter-btn" @click="goSend()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 查看物流 -->
    <el-dialog
      :visible.sync="logisticsVisible"
      title="查看物流"
      width="40%"
      :before-close="handlelogisticsClose"
      destroy-on-close
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>查看物流</p>
        <span @click="handlelogisticsClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="log-box">
        <div class="log-name">
          <p><img :src="logInfo.logo" alt="" /></p>
          <h4>
            {{ logInfo.name }}{{ logInfo.orderNo }}
            <span @click="copyCode">复制</span>
          </h4>
        </div>
        <div class="log-steps">
          <el-steps
            class="custom-steps"
            direction="vertical"
            process-status="finish"
            :active="0"
          >
            <el-step
              v-for="(item, index) in steps"
              :key="index"
              :title="item.text"
            >
              <div slot="icon" class="icon">
                <p v-if="!index" class="active"></p>
                <p v-else></p>
              </div>
              <div slot="description">
                <p class="row-time">{{ item.desc }}</p>
              </div>
            </el-step>
          </el-steps>
        </div>
        <div class="log-basic">
          <span>[收货人信息] </span> {{ itemInfo.name }}, {{ itemInfo.phone }},
          {{ itemInfo.address }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrderList,
  refundOrder,
  deleteOrder,
  getExpressList,
  getDelivery,
  checkExpress,
} from "@/api/shop";
import ClipboardJS from "clipboard";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        orderNo: null,
        goodsName: null,
        orderStatus: "",
        name: null,
      },
      tableData: [],
      firstList: [],
      secondList: [],
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value: "",
      selectList: [],
      consigneeVisible: false,
      itemInfo: {},
      coord: "",
      agreeVisible: false,
      isReturnStock: 1,
      // 发货
      sendVisible: false,
      expressList: [],
      allList: [],
      expressCode: null,
      expressNo: "",
      phoneNo: "",
      orderId: null,
      // 查看物流
      logisticsVisible: false,
      steps: [],
      logInfo: {},
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取订单列表
    async init() {
      const res = await getOrderList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.orderNo = null;
      this.queryParams.goodsName = null;
      this.queryParams.orderStatus = "";
      this.queryParams.name = null;
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.queryParams.pageNum = 1;
      this.value = "";
      this.init();
    },
    timeChange(event) {
      // console.log(event);
      if (event) {
        this.queryParams.startTime = this.$moment(event)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.endTime = this.$moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      // console.log(this.queryParams);
    },
    goDetails(id) {
      this.$router.push({
        path: "/orderdetails",
        query: {
          id,
        },
      });
    },
    // 查看收货人
    checkConsignee(row) {
      this.itemInfo = row;
      this.coord = `收货人: ${row.name},联系方式: ${row.phone},下单地址: ${row.address}`;
      this.consigneeVisible = true;
    },
    consigneeClose() {
      this.consigneeVisible = false;
    },
    // 复制地址
    copyAddress() {
      this.clipboard = new ClipboardJS(".copy-btn");
      this.clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        e.clearSelection();
      });

      this.clipboard.on("error", (e) => {
        if (!e.text) this.$message.error("暂无可复制的内容");
      });
    },
    goAgree(row) {
      this.itemInfo = row;
      this.agreeVisible = true;
    },
    agreeClose() {
      this.agreeVisible = false;
    },
    async sumbitAgree() {
      const params = {
        id: this.itemInfo.id,
        isReturnStock: this.isReturnStock,
      };
      await refundOrder(params);
      this.agreeVisible = false;
      this.init();
    },
    // 删除订单
    async cancelOrder(id) {
      await deleteOrder({ id });
      this.$message.success("订单删除成功");
      this.init();
    },
    // 发货
    async checkSend(item) {
      const res = await getExpressList();
      this.allList = res.result;
      this.expressList = res.result.map((el) => {
        return {
          label: el.title,
          value: el.id,
        };
      });
      this.itemInfo = item;
      this.isType = "add";
      this.sendVisible = true;
    },
    handlesendClose() {
      this.sendVisible = false;
    },
    // 发货
    async goSend() {
      if (!this.expressCode) {
        this.$message.error("请选择快递公司");
        return;
      }
      if (!this.expressNo) {
        this.$message.error("请输入快递单号");
        return;
      }

      if (this.expressCode == 8 && !this.phoneNo) {
        this.$message.error("顺丰快递必须添加收或寄件人手机尾号4位");
        return;
      }
      const arr = this.allList.filter((el) => el.id === this.expressCode);
      // console.log(this.expressCode, this.expressNo, this.expressList);
      const expressCode = arr[0].code;
      const params = {
        expressCode,
        expressNo:
          expressCode === "SF"
            ? `${this.expressNo}:${this.phoneNo}`
            : this.expressNo,
        id: this.itemInfo.id,
      };
      await getDelivery(params);
      this.$message.success("订单发货成功！");
      this.sendVisible = false;
      this.init();
    },
    // 查看物流
    async checkLog(item) {
      this.itemInfo = item;
      const res = await checkExpress(item.expressNo, item.expressCode);
      let result = JSON.parse(res.result);
      let steps = [];
      if (result.code === "OK") {
        steps = result.list.map((el) => {
          return {
            text: el.content,
            desc: el.time,
          };
        });
      } else {
        steps = [
          {
            text: result.msg,
            desc: result.time,
          },
        ];
      }
      result.orderNo = result.no.split(":")[0];
      this.logInfo = result;
      this.steps = steps;
      this.logisticsVisible = true;
    },
    handlelogisticsClose() {
      this.logisticsVisible = false;
    },
    async copyCode() {
      const textToCopy = this.logInfo.orderNo;
      await navigator.clipboard.writeText(textToCopy);
      // console.log("复制成功");
      this.$message.success("复制成功");
    },
  },
};
</script>
<style lang="scss" scoped>
.order {
  position: relative;
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;
        > span {
          display: block;
          width: 15px;
          height: 1px;
          background: #979797;
          margin: 0 6px;
        }
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
          min-width: 80px;
        }
        .el-input,
        .el-range-editor {
          width: 216px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox {
      display: flex;
      align-items: center;
    }
  }
  .content {
    .cover {
      display: flex;
      justify-content: center;
      width: 44px;
      height: 44px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    // .textOrange-btn {
    //   margin: 0 10px;
    // }
  }
  .consignee-box {
    position: relative;
    p {
      display: flex;
      flex-direction: column;
      font-weight: 600;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin-bottom: 16px;
      span {
        display: block;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin-top: 4px;
      }
    }
    .copy-btn {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #ff5d2f;
      line-height: 20px;
      cursor: pointer;
      img {
        width: 20px;
        height: 20px;
        margin-right: 2px;
      }
    }
  }
  ::v-deep .agree-box {
    width: 100%;
    > div {
      font-weight: 400;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.85);
      line-height: 20px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      p {
        min-width: 100px;
        text-align: right;
      }
    }
    > div:last-child {
      margin: 0;
    }
    .el-radio {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      .el-radio__label {
        color: rgba(0, 0, 0, 0.85);
      }
      .el-radio__inner {
        width: 16px;
        height: 16px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
      }
      .is-checked {
        .el-radio__inner {
          border: 1px solid #ff5d2f;
        }
        .el-radio__inner::after {
          width: 8px;
          height: 8px;
          background: #ff5d2f;
        }
      }
    }
    input[aria-hidden="true"] {
      display: none !important;
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
      .el-radio__inner {
      box-shadow: none !important;
    }
  }
  ::v-deep .address-box {
    > div {
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      span {
        font-weight: 400;
        font-size: 14px;
        color: rgba(51, 51, 51, 0.85);
        line-height: 20px;
        display: block;
        min-width: 100px;
        text-align: right;
        margin-right: 10px;
      }
      .el-input,
      .el-range-editor,
      .el-select {
        width: 216px;
      }
      input::-webkit-input-placeholder {
        /* WebKit browsers */
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.25);
        line-height: 22px;
      }
      .el-input__inner,
      .el-range-input {
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 22px;
      }
      .el-input__suffix {
        margin: 0;
      }
    }
    > div:last-child {
      margin: 0;
    }
  }
  ::v-deep .log-box {
    .log-name {
      display: flex;
      align-items: center;
      p {
        width: 38px;
        height: 38px;
        margin-right: 10px;
        border-radius: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 100%;
        }
      }
      h4 {
        font-weight: 600;
        font-size: 15px;
        color: #262626;
        line-height: 21px;
        span {
          font-weight: 400;
          font-size: 15px;
          color: #ff5d2f;
          line-height: 21px;
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
    .log-steps {
      margin: 20px 0 4px;
      // max-height: 300px;
      // overflow-y: scroll;
      .el-step__icon {
        width: 9px;
        height: 9px;
        border: none;
      }
      .el-step__line {
        left: 4px;
        width: 1px;
        background: #c8c9ca;
        top: 9px;
        bottom: 0;
      }
      .icon {
        p {
          width: 9px;
          height: 9px;
          background: #d8d8d8;
          border-radius: 12px;
        }
        .active {
          background: #ff5d2f;
        }
      }
      .row-time {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        margin-bottom: 14px;
      }
      .el-step__title {
        padding-bottom: 2px;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
      }
      .is-finish {
        color: #ff5d2f;
        .row-time {
          color: #161616;
        }
      }
    }
    .log-basic {
      // display: flex;
      padding: 10px 18px 11px 5px;
      background: #f5f6f6;
      border-radius: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      line-height: 20px;
      span {
        font-weight: 600;
      }
    }
  }
}
</style>
